import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/course/pxb/page',
    add:'/api-ir/bachelor/course/pxb/add',
    update:'/api-ir/bachelor/course/pxb/edit',
    info:'/api-ir/bachelor/course/pxb/',
    del:'/api-ir/bachelor/course/pxb/',
    approve:'/api-ir/bachelor/course/pxb/approve',
    batchApprove:'/api-ir/bachelor/course/pxb/approveBatch',
    export:'/api-ir/bachelor/course/pxb/export'
}
// 查询平行班列表
export function list (data) {
    return baseAPI.axiosData(api.list,'post',data)
}
// 新增平行班
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改平行班
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询平行班信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除平行班
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 平行班审核
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}
// 平行班批量审核
export function batchApprove (data) {
    return baseAPI.axiosData(api.batchApprove,'post',data)
}

export function exportTable (data) {
    return baseAPI.axiosData(api.export,'post',data)
}